import { WrapPageElementBrowserArgs } from "gatsby";
import * as React from "react";
import * as CookieConsent from "vanilla-cookieconsent";
import {
  LayoutWrapper,
  ProvidersWrapper,
} from "./providers-and-layout-wrappers";
import {
  createPluginConfig,
  CookiesCategories,
} from "./src/components/cookie-consent/cookie-consent-config";
import i18n from "./src/shared/locales/i18n";
import {
  initGA,
  loadGAAnonymously,
  sendPageView,
} from "./src/shared/utils/google-analytics";

interface WrapRootElementArgs {
  element: React.ReactNode;
}

export const onInitialClientRender = () => {
  const currentLang = i18n.language || "pl";
  const config = createPluginConfig(currentLang);

  document.documentElement.classList.add("cc--darkmode");
  CookieConsent.run(config);

  const cookieConfig = CookieConsent.getCookie();
  const hasConsent = !!cookieConfig.categories?.includes(
    CookiesCategories.analytics
  );

  if (hasConsent) {
    initGA();
  } else {
    loadGAAnonymously(); // optional
  }
};

export const onRouteUpdate = ({ location }) => {
  sendPageView(location.pathname);
};

export const wrapRootElement = ({ element }: WrapRootElementArgs) => {
  return <ProvidersWrapper>{element}</ProvidersWrapper>;
};

export const wrapPageElement = ({ element }: WrapPageElementBrowserArgs) => {
  return <LayoutWrapper>{element}</LayoutWrapper>;
};
